import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error("CSRF token not found!");
}
Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        form: {
            business: {
                name: "",
                county: "",
                town: "",
                address: "",
                website: ""
            },

            contact: {
                name: "",
                surname: "",
                email: "",
                phone: ""
            },

            logo: "",
            header: "",
            picture: "",
            color_theme: "",

            social_linkedin: "",
            social_facebook: "",
            social_twitter: "",
            social_instagram: "",
            social_youtube: "",
            social_blog_url: "",

            company_description: "",
            keywords: [],
            number_of_employees: "",

            referrer: "",

            customer_testimonials: [],

            categories: [],

            first_name: "",
            last_name: "",
            email: "",
            password: "",
            password_confirmation: "",
            email_confirmation: {
                status: true, // If confirmation mail is sent
                check: false //if confirmation code is correct
            }
        },
        loadingState: false,
        countries_list: [],
        categories_list: [],
        step: 1,
        stepPassed: 1,
        server_errors: {},
        active_page: "basic-information",
        subscriptions: {
            status: false, //true for yearly, false for monthly
            pro: {
                monthly: 5,
                yearly: 60
            },
            premium: {
                monthly: 7.99,
                yearly: 95.88
            }
        },
        testimonials: []
    },
    getters: {
        getStep: state => {
            return state.step;
        },
        getForm: state => {
            return state.active_page;
        },
        getBusinessForm: state => {
            return state.form.business;
        },
        getContactForm: state => {
            return state.form.contact;
        },
        getSubscriptionStatus: state => {
            return state.subscriptions.status;
        },
        getSubscriptionPro: state => {
            return state.subscriptions.status
                ? state.subscriptions.pro.yearly
                : state.subscriptions.pro.monthly;
        },
        getSubscriptionPremium: state => {
            return state.subscriptions.status
                ? state.subscriptions.premium.yearly
                : state.subscriptions.premium.monthly;
        },
        getEmailConfirmationMail: state => {
            return state.form.email_confirmation.status;
        },

        getCountriesList: state => {
            return state.countries_list;
        },

        getCategoriesList: state => {
            return state.categories_list;
        },

        getServerErrors: state => {
            return state.server_errors;
        },
        getStepPassed: state => {
            return state.stepPassed;
        },
        getComponentType: state => {
            return state.component_type;
        },
        getLoadingState: state => {
            return state.loadingState;
        },
        getTestimonials: state => {
            return state.testimonials;
        }
    },
    mutations: {
        SAVE_BASIC_INFORMATION: (state, payload) => {
            state.form.business = payload.business;
            state.form.contact = payload.contact;
        },
        SAVE_COMPANY_PROFILE: (state, payload) => {
            // state.form.logo_path = payload.company_logo;
            // state.form.cover_image_path = payload.cover_image;

            state.form.logo = payload.company_logo;
            state.form.header = payload.cover_image;
            state.form.social_linkedin = payload.linkedin;
            state.form.social_facebook = payload.facebook;
            state.form.social_twitter = payload.twitter;
            state.form.social_instagram = payload.instagram;
            state.form.social_youtube = payload.youtube;
            state.form.social_blog_url = payload.blog;
        },
        SAVE_SEO: (state, payload) => {
            state.form.company_description = payload.company_description;
            state.form.keywords = payload.keywords;
            state.form.number_of_employees = payload.number_of_employees;
            state.form.referrer = payload.referrer;
        },
        SAVE_CATEGORIES: (state, payload) => {
            state.categories = payload.categories;
        },
        SAVE_YOUR_PROFILE: (state, payload) => {
            state.form.picture = payload.picture;
            state.form.first_name = payload.first_name;
            state.form.last_name = payload.last_name;
            state.form.phone = payload.phone;
            state.form.email = payload.email;
            state.form.password = payload.password;
            state.form.password_confirmation = payload.password_confirmation;
        },

        SAVE_SERVER_ERRORS: (state, payload) => {
            state.server_errors = payload;
        },
        SET_COMPONENT_TYPE: (state, payload) => {
            state.component_type = payload;
        },
        MOVE_TO_NEXT_STEP: state => {
            window.scrollTo(0, 0);
            let page;
            state.step++;
            if (state.stepPassed < state.step) {
                state.stepPassed = state.step;
            }

            switch (state.step) {
                case 1:
                    page = "basic-information";
                    break;
                case 2:
                    page = "company-profile";
                    break;
                case 3:
                    page = "seo";
                    break;
                case 4:
                    page = "category";
                    break;
                case 5:
                    page = "profile";
                    break;
                case 6:
                    page = "email-confirmation";
                    break;
                default:
                    page = "listing-preview";
                    break;
            }
            state.active_page = page;
        },
        CHANGE_STEP_TO: (state, payload) => {
            state.step = payload - 1;
        },
        CHANGE_SUBSCRIPTION: (state, payload) => {
            state.subscriptions.status = payload;
        },
        CODE_INCORECT: state => {
            state.form.email_confirmation.check = false;
            state.form.email_confirmation.status = false;
        },
        CODE_RESET: state => {
            state.form.email_confirmation.check = false;
            state.form.email_confirmation.status = true;
        },
        POPULATE_STATE_COUNTRIES: (state, payload) => {
            state.countries_list = payload;
        },
        POPULATE_STATE_CATEGORIES: (state, payload) => {
            state.categories_list = payload;
        },
        REFRESH_STATE: state => {
            state.form = {
                business: {
                    name: "",
                    county: "",
                    town: "",
                    address: "",
                    website: ""
                },
                contact: {
                    name: "",
                    surname: "",
                    email: "",
                    phone: ""
                },
                logo: "",
                header: "",
                picture: "",
                color_theme: "",

                social_linkedin: "",
                social_facebook: "",
                social_twitter: "",
                social_instagram: "",
                social_youtube: "",
                social_blog_url: "",

                company_description: "",
                keywords: [],
                number_of_employees: "",

                referrer: "",

                customer_testimonials: [],

                categories: [],

                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                password: "",
                password_confirmation: "",
                email_confirmation: {
                    status: true, // If confirmation mail is sent
                    check: false //if confirmation code is correct
                }
            };

            state.subscriptions = {
                status: false, //true for yearly, false for monthly
                pro: {
                    monthly: 5,
                    yearly: 60
                },
                premium: {
                    monthly: 7.99,
                    yearly: 95.88
                }
            };
            state.loadingState = false;
            (state.server_errors = {}), (state.stepPassed = 1);
            state.step = 1;
            state.active_page = "basic-information";
        },
        CHANGE_LOADING_STATE: state => {
            state.loadingState = !state.loadingState;
        },
        SET_TESTIMONIALS: (state, payload) => {
            state.testimonials = [...payload];
        }
    },
    actions: {
        saveBasicInformation: ({ commit }, payload) => {
            commit("SAVE_BASIC_INFORMATION", payload);
            commit("MOVE_TO_NEXT_STEP");
        },
        saveCompanyProfile: ({ commit }, payload) => {
            commit("SAVE_COMPANY_PROFILE", payload);
            commit("MOVE_TO_NEXT_STEP");
        },
        saveSeo: ({ commit }, payload) => {
            commit("SAVE_SEO", payload);
            commit("MOVE_TO_NEXT_STEP");
        },
        saveCategories: ({ commit, state }, payload) => {
            commit("SAVE_CATEGORIES", payload);
            if (state.component_type == "logged") {
                commit("CHANGE_LOADING_STATE");
                const form = new FormData();
                const business = JSON.stringify({
                    name: state.form.business.name,
                    city_id: state.form.business.town.id,
                    country_id: state.form.business.country.id,
                    address: state.form.business.address,
                    website: state.form.business.website,
                    email: state.form.business.email,
                    phone: state.form.business.phone,
                    contact_first_name: state.form.contact.name,
                    contact_last_name: state.form.contact.surname,
                    contact_email: state.form.contact.email,
                    contact_phone: state.form.contact.phone,
                    contact_occupation: state.form.contact.position,

                    media_facebook: state.form.social_facebook,
                    media_twitter: state.form.social_twitter,
                    media_linkedin: state.form.social_linkedin,
                    media_instagram: state.form.social_instagram,
                    media_youtube: state.form.social_youtube,
                    media_blog: state.form.social_blog_url,
                    description: state.form.company_description,
                    keywords: state.form.keywords,
                    referrer: state.form.referrer,
                    no_of_employees: state.form.number_of_employees
                });

                form.append("business", business);
                if (state.form.logo) form.append("logo", state.form.logo);
                if (state.form.header) form.append("header", state.form.header);
                form.append(
                    "categories",
                    JSON.stringify(state.categories.map(x => x.id))
                );

                const options = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                };
                axios
                    .post("/businesses", form, options)
                    .then(response => {
                        commit("SAVE_SERVER_ERRORS", {});
                        commit("CHANGE_LOADING_STATE");
                        if (response.data.success) {
                            commit("REFRESH_STATE");



                            window.location.replace(response.data.url);
                        }
                    })
                    .catch(error => {
                        commit(
                            "SAVE_SERVER_ERRORS",
                            error.response.data.errors
                        );
                    });
            } else {
                commit("MOVE_TO_NEXT_STEP");
            }
        },
        saveYourProfile: ({ commit, state }, payload) => {
            commit("SAVE_YOUR_PROFILE", payload);
            commit("CHANGE_LOADING_STATE");
            const form = new FormData();
            const user = JSON.stringify({
                first_name: state.form.first_name,
                last_name: state.form.last_name,
                email: state.form.email,
                password: state.form.password,
                password_confirmation: state.form.password_confirmation,
                referrer: state.form.referrer,
                phone: state.form.phone
            });
            const business = JSON.stringify({
                name: state.form.business.name,
                city_id: state.form.business.town.id,
                country_id: state.form.business.country.id,
                address: state.form.business.address,
                website: state.form.business.website,
                email: state.form.business.email,
                phone: state.form.business.phone,
                contact_first_name: state.form.contact.name,
                contact_last_name: state.form.contact.surname,
                contact_email: state.form.contact.email,
                contact_phone: state.form.contact.phone,
                contact_occupation: state.form.contact.position,

                media_facebook: state.form.social_facebook,
                media_twitter: state.form.social_twitter,
                media_linkedin: state.form.social_linkedin,
                media_instagram: state.form.social_instagram,
                media_youtube: state.form.social_youtube,
                media_blog: state.form.social_blog_url,
                description: state.form.company_description,
                keywords: state.form.keywords,
                referrer: state.form.referrer,
                no_of_employees: state.form.number_of_employees
            });
            form.append("user", user);
            form.append("business", business);

            if (state.form.logo) form.append("logo", state.form.logo);
            if (state.form.header) form.append("header", state.form.header);
            if (state.form.picture) form.append("picture", state.form.picture);

            form.append(
                "categories",
                JSON.stringify(state.categories.map(x => x.id))
            );

            // let form = {
            //     user:{
            //          first_name:state.form.first_name,
            //          last_name:state.form.last_name,
            //          email:state.form.email,
            //          picture:state.form.profile_picture_path,
            //          password:state.form.password,
            //          password_confirmation:state.form.password_confirmation,
            //          referrer: state.form.referrer,
            //     },
            //     business:{
            //          name:state.form.business.name,
            //          city_id: state.form.business.town.id,
            //          country_id: state.form.business.country.id,
            //          address:state.form.business.address,
            //          website:state.form.business.website,
            //          email: state.form.business.email,
            //          phone: state.form.business.phone,
            //          contact_first_name:state.form.contact.name,
            //          contact_last_name:state.form.contact.surname,
            //          contact_email:state.form.contact.email,
            //          contact_phone:state.form.contact.phone,
            //          contact_occupation: state.form.contact.position,
            //          logo:state.form.logo_path,
            //          header:state.form.cover_image_path,
            //
            //          media_facebook:state.form.social_facebook,
            //          media_twitter:state.form.social_twitter,
            //          media_linkedin:state.form.social_linkedin,
            //          media_instagram:state.form.social_instagram,
            //          media_youtube:state.form.social_youtube,
            //          media_blog:state.form.social_blog_url,
            //          description:state.form.company_description,
            //          keywords:state.form.keywords,
            //          referrer: state.form.referrer,
            //          no_of_employees:state.form.number_of_employees
            //      },
            //     categories: state.categories.map(x => x.id)
            // };
            const options = {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            };
            axios
                .post("/register", form, options)
                .then(response => {
                    commit("CHANGE_LOADING_STATE");
                    commit("SAVE_SERVER_ERRORS", {});
                    commit("MOVE_TO_NEXT_STEP");
                })
                .catch(error => {
                    commit("SAVE_SERVER_ERRORS", error.response.data.errors);
                    commit("CHANGE_LOADING_STATE");
                });
        },
        changeStep: ({ commit, state }, payload) => {
            if (payload > state.stepPassed) {
                return;
            }
            commit("CHANGE_STEP_TO", payload);
            commit("MOVE_TO_NEXT_STEP");
        },
        changeSubscription: ({ commit }, payload) => {
            commit("CHANGE_SUBSCRIPTION", payload);
        },
        checkCode: ({ commit }, payload) => {
            commit("CHANGE_LOADING_STATE");
            axios
                .post("/api/send-verification-code", { code: payload.code, gdpr:payload.gdpr, u_automatic_subscribe: payload.u_automatic_subscribe, terms_and_conditions: payload.terms_and_conditions })
                .then(response => {
                    commit("CHANGE_LOADING_STATE");
                    if (response.data.success) {
                        window.location.replace(
                            APP_URL + "/confirmation/" + payload.code
                        );
                        // commit("MOVE_TO_NEXT_STEP");
                    } else {
                        commit("CHANGE_LOADING_STATE");
                        commit("CODE_INCORECT");
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        resendCode: ({ commit }) => {
            axios.post("/api/resend-verification-code").then(response => {
                commit("CODE_RESET");
            });
        },
        initialiseState: ({ commit }, payload = null) => {
            commit("REFRESH_STATE");
            commit("SAVE_SERVER_ERRORS", {});
            if (payload) commit("SET_COMPONENT_TYPE", payload);
            axios.get("/api/countries").then(response => {
                console.log(response);
                commit("POPULATE_STATE_COUNTRIES", response.data.countries);
            });

            axios.get("/api/categories").then(response => {
                console.log(response);
                commit("POPULATE_STATE_CATEGORIES", response.data.categories);
            });

            axios.get("/api/testimonials").then(response => {
                commit("SET_TESTIMONIALS", response.data);
            });
        },
        setTestimonials: ({ commit }) => {
            axios.get("/api/testimonials").then(response => {
                commit("SET_TESTIMONIALS", response.data);
            });
        }
    },
    plugins: [createPersistedState()]
});
